import React from 'react'
import { Card as MUICard, CardContent as MUICardContent } from '@mui/material'

const Card = ({
  children,
  sx,
  contentSx,
  padding = '1rem',
  hoverLift = true,
  overflow = 'hidden',
  ...rest
}) => {
  return (
    <MUICard
      sx={{
        width: '100%',
        borderRadius: 3,
        background: 'white',
        transition: 'all 0.3s ease',
        position: 'relative',
        overflow: overflow,
        ...(hoverLift ? { '&:hover': { transform: 'translateY(-4px)' } } : {}),
        ...sx,
      }}
      {...rest}
    >
      <MUICardContent sx={{ p: padding, '&:last-child': { pb: padding }, ...contentSx }}>
        {children}
      </MUICardContent>
    </MUICard>
  )
}

export default Card
